import React from 'react';
export function InfoBox() {
  return <div className="bg-green-bg rounded-[10px] px-[26px] py-[22px] my-8" data-id="element-73">
      <div className="font-sans text-[0.7rem] font-bold tracking-[0.12em] uppercase text-green mb-2" data-id="element-74">
        Was Experten dazu sagen
      </div>
      <p className="font-sans text-[0.9rem] text-green-text mb-0 leading-[1.65]" data-id="element-75">
        Der Darm beherbergt rund 70 % des Immunsystems – beim Hund wie beim
        Menschen. Wenn die Balance der Darmbakterien gestört ist, kann das zu
        einer überschießenden Immunreaktion führen, die sich als Juckreiz,
        Hautreizungen oder Unverträglichkeiten äußert. Eine gezielte
        Unterstützung der Darmflora kann diesen Kreislauf unterbrechen.
      </p>
    </div>;
}